import React from 'react'
import moment from 'moment'
import { useHandler } from 'labguard-cdk'
import useSelectedDate from './useSelectedDate'

const isBetween = (date, from, to) => moment(date).isBetween(from, to, 'day', '[]')

export default function useCalendarEventsTableHandlers({ data }) {
  const [date, selectDate] = useSelectedDate()

  const selectedIndex = React.useMemo(() => data.findIndex(({ from, to }) => isBetween(date, from, to)), [data, date])
  const isRowHighlighted = useHandler(({ rowData }) => isBetween(date, rowData.from, rowData.to))
  const onRowClick = useHandler(({ rowData }) => selectDate(rowData.from))

  return { selectedIndex, isRowHighlighted, onRowClick }
}
